import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { DomainContext } from '../../domain-repository/DomainRepository'

import DriverInfoHeader from '../../components/PageHeader'
import Footer from '../../components/Footer'
import ConfirmValuesCheckBox from '../../components/ConfirmValuesCheckBox'
import { DriverInfoReviewSection, DriverInfoReviewSectionItem } from './components/review-section'
import LegalInformation from '../../components/legal-information-section/LegalInformation'
import TrackingPage from '../../components/TrackingPage'

function AdditionalDriverInfoReview(props) {
  const { t } = useTranslation()

  const {
    language,
    additionalDriverInfo,
    hasAdditionalDriver,
    addAdditionalDriver,
    wasAdditionalDriverInfoVerified,
    setWasAdditionalDriverInfoVerified,
    additionalDriverPolicyAndTermsVerified,
    setAdditionalDriverPolicyAndTermsVerified,
    flowNextRoute,
  } = useContext(DomainContext)

  const {
    fullName,
    birthDate,
    driversLicense,
    driversLicenseIssuedPlace,
    driversLicenseIssuedDate,
    driversLicenseExpirationDate,
    documentID,
    iDIssuedCountry,
    iDExpireDate,
  } = additionalDriverInfo

  function handleNextClick() {
    if (!wasAdditionalDriverInfoVerified || !additionalDriverPolicyAndTermsVerified) { return; }

    if (!hasAdditionalDriver()) {
      addAdditionalDriver()
    }
    props.history.push({
      pathname: props.history.location.state?.returnTo || "/driver-info-review",
      state: props.history.location.state,
    });
  }

  function onEditClick() {
    props.history.push("/additional-driver-info-step/1?edit=true");
  }

  return (
    <div>
      <DriverInfoHeader
        title={t('personalInfo')}
        active={1}
        progress={'39.5%'}
        handleLogoClick={() => props.history.push('/start')}
      />
      <main className='page-layout'>
        <div className="driver-review resumo-dados grow" style={{ height: '100%' }}>
          <div className="dados-content">
            <div className="driver-review__title">
              <div className="container">
                <h1>{t("reviewAdditionalDriverInfo")}</h1>
              </div>
            </div>
            <div className="container">
              <DriverInfoReviewSection title={t('personalInfo')}>
                <DriverInfoReviewSectionItem label={t('name')} value={fullName} onEditClick={onEditClick} />
                <DriverInfoReviewSectionItem label={t('birthDate')} value={birthDate} onEditClick={onEditClick} />
              </DriverInfoReviewSection>
              <DriverInfoReviewSection title={t('documents')}>
                <DriverInfoReviewSectionItem label={t('driversLicense')} value={driversLicense} onEditClick={onEditClick} />
                <DriverInfoReviewSectionItem label={t('driversLicenseIssuedCountry')} value={driversLicenseIssuedPlace} onEditClick={onEditClick} />
                <DriverInfoReviewSectionItem label={t('driversLicenseIssuedDate')} value={driversLicenseIssuedDate} onEditClick={onEditClick} />
                <DriverInfoReviewSectionItem label={t('driversLicenseExpirationDate')} value={driversLicenseExpirationDate} onEditClick={onEditClick} />
              </DriverInfoReviewSection>
              <LegalInformation
                label={t('legalInformationLabel')}
                driverInfoVerified={wasAdditionalDriverInfoVerified}
                setDriverInfoVerified={setWasAdditionalDriverInfoVerified}
                driverInfoVerifiedLabel={t('submitedInformationIsTrue')}
                policyAndTermsVerified={additionalDriverPolicyAndTermsVerified}
                setPolicyAndTermsVerified={setAdditionalDriverPolicyAndTermsVerified}
                policyAndTermsLabel={t('policyAndTermsLabel')}
                policyLabel={t('policyLabel')}
                termsLabel={t('termsLabel')}
                handlePrivacyPolicyClick={() => props.history.push('/privacy-policy')}
                handleTermsConditionsClick={() => props.history.push('/terms-conditions')}
                pageUrl={'/additional-driver-info-review'}
                history={props.history}
                search={props.location.search}
                state={props.location.state}
              />
            </div>
          </div>
        </div>
        <Footer
          handlePrevClick={() => props.history.push('/additional-driver-info-step/1')}
          nextDisabled={!wasAdditionalDriverInfoVerified || !additionalDriverPolicyAndTermsVerified}
          handleNextClick={handleNextClick}
        />
      </main>
    </div>
  )
}

export default TrackingPage(AdditionalDriverInfoReview, 78)